/// <summary>
/// This visual provides an interface for the typemill documentation<br/>
/// Supports two display modes: "embedded" (iframe) and "tab" (new browser tab)<br/>
/// The page existence hierarchy check (Tech -> Admin -> Customer) is done
/// in redirect.html (same origin as Typemill) to avoid CORS issues.
/// </summary>
/// <remarks>
/// Author: MKU<br/>
/// Date: 12.06.2026<br/>
/// Copyright ©: EUDT GmbH 2024 <br/>
/// Version-History:<br/>
/// **********************************************************************<br/>
/// *** v1.2.0 - 20.08.2026                                            ***<br/>
/// **********************************************************************<br/>
/// * - moved page check to redirect.html (same-origin, no CORS)        *<br/>
/// **********************************************************************<br/>
/// *** v1.0.0 - 12.06.2026                                            ***<br/>
/// **********************************************************************<br/>
/// * - generates basic functionality                                    *<br/>
/// **********************************************************************<br/>
$.widget("bluaul.Documentation", jQuery.common.vcBaseV4, {

    _create: function () {
        this._createVisual(416);
        this._super();
    },

    _initHTML: function () {
        var me = this;
        try {
            return true;
        } catch (e) {
            me.writeError('_initHTML', e);
            return false;
        }
    },

    _initEvents: function () {
        var me = this;
        try {
            var loginUrl = me.specific ? me.specific.loginUrl : null;
            var candidateUrlsStr = me.specific ? me.specific.candidateUrls : null;
            var displayMode = me.specific ? me.specific.displayMode : 'embedded';

            if (!loginUrl || !candidateUrlsStr) {
                me.writeError('_initEvents', 'Login URL or candidate URLs missing in me.specific.');
                return false;
            }

            var typemillBaseUrl = loginUrl.split('/tm/loginlink')[0];
            var logoutUrl = typemillBaseUrl + '/tm/logout';
            var timestamp = Date.now();

            if (displayMode === 'tab') {
                // Build redirect.html URL with candidate URLs for same-origin page checking
                var redirectPageUrl = typemillBaseUrl + '/redirect.html' +
                    '?logout=' + encodeURIComponent(logoutUrl + '?t=' + timestamp) +
                    '&login=' + encodeURIComponent(loginUrl + '&t=' + timestamp) +
                    '&candidates=' + encodeURIComponent(candidateUrlsStr);

                if (window._documentationTab && !window._documentationTab.closed) {
                    window._documentationTab.location.href = redirectPageUrl;
                } else {
                    var newTab = window.open(redirectPageUrl, '_blank');
                    if (!newTab || newTab.closed || typeof newTab.closed === 'undefined') {
                        window.open(redirectPageUrl);
                    }
                }

                // Clean up the reference
                window._documentationTab = null;

            } else {
                // Embedded mode - no page check needed, just login and show first candidate
                var $logoutFrame = $('<iframe>', {
                    src: logoutUrl + '?t=' + timestamp,
                    style: 'display:none;'
                }).appendTo('body');

                $logoutFrame.on('load', function () {
                    $logoutFrame.remove();

                    var $loginFrame = $('<iframe>', {
                        src: loginUrl + '&t=' + timestamp,
                        style: 'display:none;'
                    }).appendTo('body');

                    $loginFrame.on('load', function () {
                        $loginFrame.remove();
                        var $iframe = me.element.find('#typemill-frame');
                        if ($iframe.length) {
                            $iframe.attr('src', candidateUrlsStr.split('|')[0]);
                        }
                    });
                });
            }

            return true;
        } catch (e) {
            me.writeError('_initEvents', e);
            return false;
        }
    }
});